import styled, { css } from 'styled-components';
import closeIcon from '../images/close-icon.svg';
import backIcon from '../images/back-icon.svg';
import { device } from '../device';

export const theme1 = {
  primary: '#53565A',
  darkBlue: '#003B5C',
  secondary: '#00A3E0',
  white: '#FFFFFF',
  red: '#FC4C02',
  buttonBgHover: '#DE3D00',
  segment: '#D7D2CB',
  featuresBg: '#F3F2EF',
  disabled: '#CCCCCC',
};

export const Button = styled.button`
  position: relative;
  margin-left: 0;
  font-size: 5vw;
  border-radius: 0 3vw;
  padding: 0 10vw;
  height: 13vw;
  border: 0;
  background: ${(props) => props.theme.red};
  color: ${(props) => props.theme.white};
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1;
  @media ${device.tablet} {
    padding: 0 35px;
    font-size: 24px;
    border-radius: 0 20px;
    min-height: 60px;
    max-height: 74px;
    height: 4vw;
    max-width: 257px;
    width: auto;
    margin-left: ${({ marginLeft }) => marginLeft};
    margin-bottom: ${({ margiButton }) => margiButton};
  }
  @media (max-width: 480px) {
    margin-top: 30px;
  }
  @media (max-width: 764px) {
    margin-bottom: ${({ margiButtonMobile }) => margiButtonMobile};
  }
  :disabled {
    background: ${(props) => props.theme.disabled};
    cursor: not-allowed;
  }
  &:not(:disabled):hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.35);
    transform: translateY(-1px);
    border-radius: 3vw 0;
    @media ${device.tablet} {
      border-radius: 20px 0;
    }
  }
  &:not(:disabled):active {
    box-shadow: none;
    transform: translateY(0px);
  }
`;

export const LinkButton = styled.a`
  pointer-events: auto;
  position: relative;
  font-size: 5vw;
  border-radius: 0 3vw;
  padding: 0 10vw;
  height: 13vw;
  border: 0;
  background: ${(props) => props.theme.red};
  color: ${(props) => props.theme.white};
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1;
  @media ${device.tablet} {
    padding: 0 35px;
    font-size: 24px;
    border-radius: 0 20px;
  }

  &:hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.35);
    transform: translateY(-1px);
    border-radius: 3vw 0;
    @media ${device.tablet} {
      border-radius: 20px 0;
    }
  }
  &:active {
    box-shadow: none;
    transform: translateY(0px);
  }
`;

export const CloseButton = styled.button`
  cursor: pointer;
  pointer-events: auto;
  padding: 4vw;
  border-radius: 10px;
  background: url('${closeIcon}') no-repeat center;
  transition: transform 0.2s ease;
  background-size: 5vw;
  border: 0;
  transform: scale(1);
  @media ${device.tablet} {
    padding: 25px;
    background: url('${closeIcon}') no-repeat center;
    background-size: 31px;
  }
  &:hover {
    transform: scale(1.05);
  }
  &:active {
    transform: scale(1);
  }

  &.withSidebar {
    @media ${device.tablet} {
      right: 28%;
    }
  }
  ${(props) =>
    props.withBg &&
    css`
      background: url('${closeIcon}') no-repeat center,
        rgba(255, 255, 255, 0.85);
    `};
`;

export const BackButton = styled.button`
  cursor: pointer;
  padding: 4vw;
  border-radius: 10px;
  background: url('${backIcon}') no-repeat center, rgba(255, 255, 255, 0.85);
  background-size: 5vw;
  background-color: rgba(255, 255, 255, 0.85);
  transition: transform 0.2s ease;
  transform-origin: center;
  border: 0;
  transform: scale(1);
  @media ${device.tablet} {
    background: url('${backIcon}') no-repeat center;
    padding: 25px;
    background-size: 31px;
  }
  &:hover {
    transform: scale(1.05);
  }
  &:active {
    transform: scale(1);
  }
  ${(props) =>
    props.withBg &&
    css`
      background: url('${backIcon}') no-repeat center, rgba(255, 255, 255, 0.85);
    `};
`;
